import { createContext, useContext } from 'react'
import type { AnalysisServicesContextValue } from '../types'

const AnalysisServicesContext = createContext<
  AnalysisServicesContextValue | undefined
>(undefined)

export const AnalysisServicesProvider = AnalysisServicesContext.Provider

export const useAnalysisServices = (): AnalysisServicesContextValue => {
  const context = useContext(AnalysisServicesContext)
  if (context === undefined) {
    throw new Error(
      'useAnalysisServices must be used within an AnalysisServicesProvider'
    )
  }
  return context
}
